import React, { useEffect, useRef } from "react";
import { banner_slider } from "../../../assets/js/utilty/banner";

import pd_bg_1 from "../../../assets/media/background/pd-bg-1.png";
import pd_bg_2 from "../../../assets/media/background/pd-bg-2.png";
import pd_bg_3 from "../../../assets/media/background/pd-bg-3.png";
import pd_bg_4 from "../../../assets/media/background/pd-bg-4.png";
import pd_circle from "../../../assets/media/background/pd_circle(wh).png";

import {useSelector} from 'react-redux'

const Banner = () => {
  const banner_slider_el = useRef();


  const isAuthenticated = useSelector(e => e?.basicInfo?.isAuthenticated)
  const userType = useSelector(e => e?.basicInfo?.userDetails?.user_type)

  useEffect(() => {
    banner_slider(banner_slider_el.current.childNodes);
  }, [banner_slider_el]);

  return (
    <section id="banner">
      <div className="banner-wrapper" ref={banner_slider_el}>
        <div style={{ backgroundImage: `url(${pd_bg_1})` }}></div>
        <div style={{ backgroundImage: `url(${pd_bg_2})` }}></div>
        <div style={{ backgroundImage: `url(${pd_bg_3})` }}></div>
        <div style={{ backgroundImage: `url(${pd_bg_4})` }}></div>
      </div>

      <div className="banner-text">
        <div className="container">
          <p>
            Discover the Poncore Dispatch Marketplace 
          </p>

          <div className="empty-line bg-white"></div>

          <div className="banner-btn">
            {
              userType !== "shipper" &&
              <a href={isAuthenticated ? "/search-load-post" : "/auth/sign-up?type=carrier"} className="home-btns bg-white">
                <i className="fa-solid fa-dolly"></i>
                Find Load
              </a>
            }

            {
              userType !== "carrier" &&
              <a href={isAuthenticated ? "/search-carrier" : "/auth/sign-up?type=shipper"} className="home-btns bg-white">
                <i className="fa-solid fa-truck-moving"></i>
                Find Carrier
              </a>
            }
          </div>
        </div>
      </div>

      <img className="circle_main" src={pd_circle} alt="pd_circle" />
    </section>
  );
};

export default Banner;
